// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.level_div {
    padding: 10px;
    color: var(--text-color, #1e1e1e);
}

.comp_level_card {
    background-color: var(--surface-color, #ffffff);
    border-radius: 8px;
    margin: 10px 0;
    display: flex;
    justify-content: center;
    padding: 12px;
    box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.06));
    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));
    transition: all 0.3s ease;

    img {
        width: 112px;
        height: 112px;
        padding: 4px;
        object-fit: contain;
        border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);
        border-radius: 22px;
        background: color-mix(
            in srgb,
            var(--brand-primary-light, var(--brand-primary, #0877bc)) 18%,
            #ffffff
        );
    }
}

.dark-mode .comp_level_card img,
html[data-theme="dark"] .comp_level_card img {
    background: color-mix(
        in srgb,
        var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,
        #1f2937
    );
    border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);
}

.select_level {
    background-color: var(--surface-color, #ffffff);
    color: var(--text-color, #1e1e1e);
    border: 1px solid var(--border-color, #e2e8f0);
}

.level_title {
    font-size: 13px;
    margin: 10px 0;
    color: var(--text-color, #1e1e1e);
}

.comp_level_info {
    flex: 1 1;
    min-width: 0;
}

.comp_level_value {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    color: var(--text-color, #1e1e1e);
}

.level_title {
    font-size: 16px;
    font-weight: 800;
    color: var(--text-color, #1e1e1e);
}

.level_des {
    font-size: 14px;
    margin-top: 10px;
    color: var(--text-secondary, #838383);
}`, "",{"version":3,"sources":["webpack://./src/pages/Player/Level.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,+DAA+D;IAC/D,0DAA0D;IAC1D,yBAAyB;;IAEzB;QACI,YAAY;QACZ,aAAa;QACb,YAAY;QACZ,mBAAmB;QACnB,oFAAoF;QACpF,mBAAmB;QACnB;;;;SAIC;IACL;AACJ;;AAEA;;IAEI;;;;KAIC;IACD,gFAAgF;AACpF;;AAEA;IACI,+CAA+C;IAC/C,iCAAiC;IACjC,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iCAAiC;AACrC;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qCAAqC;AACzC","sourcesContent":[".level_div {\n    padding: 10px;\n    color: var(--text-color, #1e1e1e);\n}\n\n.comp_level_card {\n    background-color: var(--surface-color, #ffffff);\n    border-radius: 8px;\n    margin: 10px 0;\n    display: flex;\n    justify-content: center;\n    padding: 12px;\n    box-shadow: 0 4px 12px var(--shadow-color, rgba(0, 0, 0, 0.06));\n    border: 1px solid var(--border-color, rgba(0, 0, 0, 0.05));\n    transition: all 0.3s ease;\n\n    img {\n        width: 112px;\n        height: 112px;\n        padding: 4px;\n        object-fit: contain;\n        border: 1px solid color-mix(in srgb, var(--brand-primary, #0877bc) 22%, transparent);\n        border-radius: 22px;\n        background: color-mix(\n            in srgb,\n            var(--brand-primary-light, var(--brand-primary, #0877bc)) 18%,\n            #ffffff\n        );\n    }\n}\n\n.dark-mode .comp_level_card img,\nhtml[data-theme=\"dark\"] .comp_level_card img {\n    background: color-mix(\n        in srgb,\n        var(--brand-primary-light, var(--brand-primary, #0877bc)) 22%,\n        #1f2937\n    );\n    border-color: color-mix(in srgb, var(--brand-primary, #0877bc) 32%, transparent);\n}\n\n.select_level {\n    background-color: var(--surface-color, #ffffff);\n    color: var(--text-color, #1e1e1e);\n    border: 1px solid var(--border-color, #e2e8f0);\n}\n\n.level_title {\n    font-size: 13px;\n    margin: 10px 0;\n    color: var(--text-color, #1e1e1e);\n}\n\n.comp_level_info {\n    flex: 1;\n    min-width: 0;\n}\n\n.comp_level_value {\n    display: flex;\n    justify-content: space-between;\n    font-size: 13px;\n    color: var(--text-color, #1e1e1e);\n}\n\n.level_title {\n    font-size: 16px;\n    font-weight: 800;\n    color: var(--text-color, #1e1e1e);\n}\n\n.level_des {\n    font-size: 14px;\n    margin-top: 10px;\n    color: var(--text-secondary, #838383);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
